import API from '../services/api';

const api = new API();

export default class AuthService {
    login({ email, password, mfaToken, sso, fragment, recaptchaResponse }) {
        return api.getJson('/login-user', {
            method: 'POST',
            body: { email, password, mfaToken, sso, fragment, 'g-recaptcha-response': recaptchaResponse },
        });
    }

    loginWithGoogle(oauthAccessToken) {
        return api.getJson('/signin/google_sign_in', {
            method: 'POST',
            body: { oauth_access_token: oauthAccessToken },
        });
    }

    checkForSSO(email) {
        return api.getJson('/should-use-sso', { method: 'POST', body: { email } });
    }

    resetPassword({ email, recaptchaResponse }) {
        return api.getJson('/reset-password', { method: 'POST', body: { email, 'g-recaptcha-response': recaptchaResponse } });
    }
}
